export const blogTitle = 'Thoughts on tech and society';
